import { buyNowFeeChartData } from "../../../data/buyNowFeeChart";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import Fee from "./Fee";

const AuctionBuyNowFeeCharts = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"AUCTION & BUY NOW FEE CHART"} dropdown={false} />
      <div className="mt-[26px] mb-20 flex flex-col gap-8">
        {buyNowFeeChartData.map((fee, index) => (
          <Fee key={fee.id} title={fee.name} />
        ))}
      </div>
    </div>
  );
};

export default AuctionBuyNowFeeCharts;
